import { render, staticRenderFns } from "./rateThat.vue?vue&type=template&id=0c636ace&scoped=true&"
import script from "./rateThat.vue?vue&type=script&lang=js&"
export * from "./rateThat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c636ace",
  null
  
)

export default component.exports